// The purpose of this file is store form field constraints (rules, messages) for a HTML form.
// Note that this data is kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the application data store object.
var dataStore = app.data;

// Create data and store it. Note that validation messages should be overriden by the server
// in the cshtml view files, to cater for different languages. The message values here are just fallbacks.
// Things should take the format of: fieldName[validatorType] = { message: "My custom message" } as per https://validatejs.org/

// It contains all flavours of constraint, incidentally applied to the register form,
// and is therefore useful for testing that all form constraint functionality is operating correctly.
// It can be deleted, but may proove to be useful in the future for testing purposes, and as a form of documentation.

// For testing basic validation

dataStore.set('validation.profileForm', {
    firstNameInput: [
        {
            type: 'present',
            errorCode: 10008
        }
    ],
    lastNameInput: [
        {
            type: 'present',
            errorCode: 10037
        }
    ],
    universityInput: [
        {
            type: 'present',
            errorCode: 10042
        }
    ],
    imageUpload: [
        {
            type: 'fileType',
            params: {
                validExtensions: ['png', 'jpeg', 'jpg']
            },
            errorCode: 10029
        },
        {
            type: 'maxFileSize',
            params: {
                size: 3 // 3MB
            },
            errorCode: 10028
        },
        {
            type: 'maxFiles',
            params: {
                size: 1
            },
            errorCode: 10055
        }
    ],
    certificateUpload: [
        {
            type: 'fileType',
            params: {
                validExtensions: ['pdf','doc','docx','jpeg','jpg']
            },
            errorCode: 10094
        },
        {
            type: 'maxFileSize',
            params: {
                size: 3 // 3MB
            },
            errorCode: 10093
        },
        {
            type: 'maxFiles',
            params: {
                size: 1
            },
            errorCode: 10092
        }
    ]
});